const PREFIX = 'AUTH'

export const AUTH_GOOGLE_PROFILE_GET = `${PREFIX}_GOOGLE_PROFILE_GET`
export const AUTH_GOOGLE_PROFILE_GET_ERROR = `${PREFIX}_GOOGLE_PROFILE_GET_ERROR`

export const AUTH_LOG_IN_ERRORS = `${PREFIX}_LOG_IN_ERRORS`

export const AUTH_PROFILE_GET = `${PREFIX}_PROFILE_GET`
export const AUTH_PROFILE_GET_ERROR = `${PREFIX}_PROFILE_GET_ERRORS`

export const AUTH_PROFILE_UPDATE = `${PREFIX}_PROFILE_UPDATE`
export const AUTH_PROFILE_UPDATE_ERROR = `${PREFIX}_PROFILE_UPDATE_ERRORS`
export const AUTH_LOADING_STATUS = `${PREFIX}_LOADING_STATUS`

export const AUTH_GET_CATEGORIES_LOG_IN = `${PREFIX}_CATEGORIES_LOG_IN`
export const AUTH_GET_CATEGORIES_REGISTER = `${PREFIX}_CATEGORIES_REGISTER`

export const AUTH_CLEAR_CATEGORIES = `${PREFIX}_CLEAR_CATEGORIES`
